/** liuce19962 可查看全部用户的答题记录 */
const ALL_RECORDS_VIEWER_USERNAME = 'liuce19962'

export function canViewAllAnswerRecords(user) {
  if (!user) return false
  const username = user.username == null ? '' : String(user.username).trim()
  return username === ALL_RECORDS_VIEWER_USERNAME
}

export function getStoredUser() {
  try {
    return JSON.parse(localStorage.getItem('user') || '{}')
  } catch {
    return {}
  }
}
